import type { ReactNode } from 'react';
import { Button, Stack, Typography } from '@packages/shared';
import { copyResponseToClipboard } from './copyResponseToClipboard';

export const CopyHeader = ({
  children,
  content,
}: {
  children: ReactNode;
  content: string | object;
}) => (
  <Stack direction="row" alignItems="center" gap={1}>
    <Typography variant="h4">{children}</Typography>
    <Button variant="text" onClick={() => copyResponseToClipboard(content)}>
      <span className="icon-emp-copy size-4" />
      Copy to clipboard
    </Button>
  </Stack>
);
